import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FetchConversaAuditoriaArgs, FetchConversaAuditoriaPayload } from '../../types';
import { auditoriaService } from './services';

const reject = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erro desconhecido';

export const fetchConversaAuditoria = createAsyncThunk<
  FetchConversaAuditoriaPayload,
  FetchConversaAuditoriaArgs,
  { rejectValue: string }
>(
  'chatAtendimento/auditoria/fetchConversa',
  async ({ conversaId, cursor, append = false }, { rejectWithValue }) => {
    try {
      const result = await auditoriaService.getConversaAuditoria({
        conversaId,
        cursor,
      });
      return { ...result, conversaId, append };
    } catch (error) {
      return rejectWithValue(reject(error));
    }
  },
);
